import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum ReturnStatusFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

export enum ReturnStatus {
  COMPLETE = "complete",
  PENDING = "pending",
  OTHER = "other",
}

export const ReturnStatusFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.RETURN_STATUS,
  ReturnStatusFilterQuery,
  z.array(createEnum(ReturnStatus)),
);

export type ReturnStatusFilter = z.infer<typeof ReturnStatusFilterSchema>;
